import { render } from "./MailItem.vue?vue&type=template&id=e39559ba&scoped=true"
import script from "./MailItem.vue?vue&type=script&lang=js"
export * from "./MailItem.vue?vue&type=script&lang=js"

import "./MailItem.vue?vue&type=style&index=0&id=e39559ba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e39559ba"]])

export default __exports__